export class WareHouseDropdownList {
  warehouseId: number;
  name: string;
}

export interface WarehouseLocations {
  locationCode: string;
  warehouseId: number;
  warehouseName: string;
  locationId: number;
  itemId: number;
}

export interface WarehouseSideBar {
  WarehouseName: string;
  locationid: number;
  WarehouseId: number;
  ItemCount: number;
  Qty: number;
  LocationCode: string;
  LastUpdate: Date;
  itemName: string;
  FBMEnabled: boolean;
}

export interface ItemMaster {
  itemId: number;
  name: string;
}

export interface WhLocationMaster {
  locationId: number;
  locationCode: string;
}

export interface WarehouseList {
  WarehouseId: number;
  Name: string;
  PriorityLavel?: any;
  PickStrategy?: any;
  AddressName: string;
  AddressLine: string;
  Location: number;
  ItemCount: number;
  Qty: number;
  LastUpdate: Date;
  City: string;
  State: string;
  Zipcode: string;
}

export interface WarehouseLocationsSummery {
  locationSummaryId: number;
  warehouseId: number;
  warehouseName: string;
  locationId: number;
  itemId: number;
  qty: number;
  locationCode: string;
  autocomplete: any;
  reasonId: number;
  reason: string;
  action: string;
}

export interface LogisticsWarehouses {
  warehouseId: number;
  name: string;
  addressName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  isFba: boolean | null;
  isFbm: boolean | null;
  priorityLavel: number | null;
  fulfillsFba: boolean | null;
  fulfillsFbm: boolean | null;
  pickStrategy: string;
  enabledLocationsOnly: boolean | null;
  fulfillsVendorCenter: boolean | null;
  pickingEnabled: boolean | null;
}
export interface WareHouse{
  id: string;
  name: string;
  addName: string;
  addressln1: string;
  addressln2: string;
  city: string;
  state: string;
  postal: string;
  country: string;
  countryCode: string;
  priority: number;
  isfba: number;
  isfbm: number;
  isvendor: number;
  picktp?: any;
  ispicking?: any;
  isfbmenonly?: any;
  isTemp: boolean;
  warehouseId:number;
}

export class WhLocationgridList_vm {
  LocationCode: number;
  WarehouseId: number;
  locationid: number;
  name: string;
  locationCode: string;
  itemName: string;
  locationSummaryId: string;
  qty: number;
  isProductdisable: number;
  itemId: number;
}

export interface LocationHistoryReasonTypeAhead {
  reasonId: number;
  reason: string;
}
export class LocationHistoryReason {
  reasonId: number;
  reason: string;
  LocationSummaryId: number;
}
